import { type FlowProducedType } from 'flow-schema';

import { NotableMarkdown, Text, isDefined } from 'common';

import { FieldReferenceCodeMirror } from '../../../../../Runs/Run/Drawer/ContentTabs/FieldReference/CodeMirror';
import { type OutputContentProps } from '../../../types';

export function SharedRestNodeOutputContent(props: OutputContentProps<FlowProducedType.Any>) {
  const { isFullHeightView } = props;
  const returnValue: unknown = props.returnValue;
  if (!isDefined(returnValue) || returnValue === '') {
    return <Text>No Response Body</Text>;
  }

  if (typeof returnValue === 'string') {
    return <NotableMarkdown>{returnValue}</NotableMarkdown>;
  }

  return (
    <FieldReferenceCodeMirror
      content={JSON.stringify(returnValue, null, 2)}
      isFullHeightView={isFullHeightView}
    />
  );
}
